import { type Components } from '@webapp/api/integrations/client'

export type IntegrationSyncLogAction = Components.Schemas.SyncLogAction

export const IntegrationSyncLogActions: {
  [K in IntegrationSyncLogAction]
} = {
  OTHER: 'OTHER',
  CREATED: 'CREATED',
  LINKED: 'LINKED',
  UPDATED: 'UPDATED',
  DELETED: 'DELETED',
  IGNORED: 'IGNORED',
  SEARCH: 'SEARCH',
} as const
